// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IHomeNewsApi,
  IHomeNewsApiRequest,
  IHomeNewsApiGetAllAttrs,
  IHomeNewsApiGetAllResponse,
  IHomeNewsApiGetAttrs,
  IHomeNewsApiGetResponse,
  IHomeNewsApiSaveAttrs,
  IHomeNewsApiSaveResponse,
} from 'interfaces/back-office/content-management/home/news/home-news-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class HomeNewsApi extends BaseApi<IHomeNewsApi> implements IHomeNewsApiRequest {
  readonly url = ApiConstant.CONTENT_HOME_NEWS_URL
  private newsUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home news list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeNewsApiGetAllAttrs} payload
   *
   * @return {Promise<IHomeNewsApiGetAllResponse>} Promise<IHomeNewsApiGetAllResponse>
   */
  async homeNews_getHomeNewsList(payload: IHomeNewsApiGetAllAttrs): Promise<IHomeNewsApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.newsUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home news
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeNewsApiGetAttrs} payload
   *
   * @return {Promise<IHomeNewsApiGetResponse>} Promise<IHomeNewsApiGetResponse>
   */
  async homeNews_getHomeNewsDetail(payload: IHomeNewsApiGetAttrs): Promise<IHomeNewsApiGetResponse> {
    try {
      const response = await this.POST(`${this.newsUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home new
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeNewsApiSaveAttrs} payload
   *
   * @return {Promise<IHomeNewsApiSaveResponse>} Promise<IHomeNewsApiSaveResponse>
   */
  async homeNews_saveHomeNews(payload: IHomeNewsApiSaveAttrs): Promise<IHomeNewsApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.newsUrl}/update/${payload.params.id}` : `${this.newsUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
